import { render } from "./MineVarslerTomminger.vue?vue&type=template&id=6ca1a008"
import script from "./MineVarslerTomminger.vue?vue&type=script&lang=js"
export * from "./MineVarslerTomminger.vue?vue&type=script&lang=js"

import "./MineVarslerTomminger.vue?vue&type=style&index=0&id=6ca1a008&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__